import api from 'api';

export const loadApplications = api(
  'GET /api/financial-results/filters/applications'
);
export const loadOwners = api('GET /api/financial-results/filters/owners');
export const loadExpenseTypes = api(
  'GET /api/financial-results/filters/expense-types'
);
export const loadImportance = api(
  'GET /api/financial-results/filters/importance'
);
export const loadStatuses = api('GET /api/financial-results/filters/statuses');
export const loadApprovers = api(
  'GET /api/financial-results/filters/approvers'
);
export const loadActions = api('GET /api/financial-results/filters/actions');
export const loadBusinessPartners = api(
  'GET /api/financial-results/filters/business-partners'
);
export const loadAffiliates = api(
  'GET /api/financial-results/filters/affiliates'
);
export const loadCustomerCompanies = api(
  'GET /api/financial-results/filters/customer-companies'
);
